import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { RequestServiceCodeEntity } from "domain/entity/RequestServiceCode/RequestServiceCodeEntity";
import { axiosGetData, axiosPostData } from "../axios/AxiosBasicImpl";
import referenceAxiosInstance from "../axios/referenceAxiosInstance";
import { RequestServiceCodeRepository } from "./RequestServiceCodeRepo";

export const RequestServiceCodeRepoImpl = (): RequestServiceCodeRepository => {

    const url = '/v1/requestServiceCode';
    const getEntities = async (): Promise<RequestServiceCodeEntity[]> => {
        return axiosGetData(referenceAxiosInstance, url, []).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const onSave = async (entity: RequestServiceCodeEntity): Promise<ResponseEntity> => {
        return await axiosPostData(referenceAxiosInstance, `${url}`, entity);
    }

    return {
        onSave: onSave,
        getEntities: getEntities
    }
}